import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ScaStoreEffects } from './effects';
import { scaStoreReducer } from './reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('sca', scaStoreReducer),
    EffectsModule.forFeature([ScaStoreEffects]),
  ],
})
export class ScaStoreModule {}
